<template>
  <div class="newsletter">
    <TextImage
      as="h2"
      eyebrow=""
      :title="title"
      :description="description"
      alt="Jacques Ramphal"
      :flipped="false"
      :red="false"
    >
      <form class="newsletter__form" @submit.prevent="subscribe">
        <div class="newsletter__row">
          <MyInput
            :id="id"
            type="email"
            name="email"
            :label="label"
            hide-label
            :placeholder="placeholder"
            autocomplete="email"
            v-model="email"
            size="large"
          />
          <MyButton
            class="newsletter__btn"
            :label="buttonLabel"
            name="submit"
            primary
            :disabled="submitting"
            @click="subscribe"
          />
        </div>

        <p
          v-if="message"
          class="newsletter__message"
          :class="{ 'is-success': isSuccess, 'is-error': !isSuccess }"
          role="status"
          aria-live="polite"
        >
          {{ message }}
        </p>
      </form>
    </TextImage>
  </div>
</template>

<script setup>
import { useSubscribe, BUTTONDOWN_ENDPOINT } from '@/utils/useSubscribe';

// Every default is the text the home page band has always shown.
const props = defineProps({
  title: { type: String, default: 'Subscribe' },
  description: {
    type: String,
    default:
      'Notes on design when making is cheap and judgment is the scarce skill. I send new essays as I publish them.',
  },
  id: { type: String, default: 'newsletter-email' },
  label: { type: String, default: 'Email address' },
  placeholder: { type: String, default: 'you@example.com' },
  buttonLabel: { type: String, default: 'Subscribe' },
  endpoint: { type: String, default: BUTTONDOWN_ENDPOINT },
  invalidMessage: { type: String, default: '' },
  successMessage: { type: String, default: '' },
  errorMessage: { type: String, default: '' },
});

const { email, message, isSuccess, submitting, subscribe } = useSubscribe({
  endpoint: props.endpoint,
  messages: {
    invalid: props.invalidMessage,
    success: props.successMessage,
    error: props.errorMessage,
  },
});
</script>

<style scoped>
.newsletter {
  /* background: var(--background-darker); */
}

/* Mobile: input and button stack, button full width. */
.newsletter__row {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-xs);
  width: 100%;
}

.newsletter__btn :deep(.custom-btn) {
  width: 100%;
}

/* Tablet and up: input and button sit in a row, button matches the field
   height and aligns to its top. */
@media only screen and (min-width: 768px) {
  .newsletter__row {
    flex-wrap: wrap;
  }

  .newsletter__row :deep(#input) {
  }

  .newsletter__btn {
    display: flex;
  }

  .newsletter__btn :deep(.custom-btn) {
    width: auto;
    height: 100%;
  }
}

.newsletter__message {
  margin: var(--spacing-xs) 0 0 0;
}

.newsletter__message.is-success {
  color: var(--color-success, green);
}

.newsletter__message.is-error {
  color: var(--color-error, red);
}
</style>
